import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import { api } from './api'
import * as actions from './actions'
import { orgId as fetchOrgId } from 'app/modules/org/selectors'

const getApiKeyForOrgEpic = (action$, { getState }) => {
  return action$
    .ofType(actions.getApiKeyForOrg.toString())
    .pluck('payload')
    .switchMap(() => {
      const orgId = fetchOrgId(getState())

      return api
        .getApiKeyForOrg(orgId)
        .map((response) => {
          if (!!response && !!response.length) {
            return actions.getApiKeyForOrgSuccess(response)
          } else {
            return actions.createApiKeyForOrg()
          }
        })
        .startWith(actions.getApiKeyForOrgPending(orgId))
        .catch(error => {
          return Observable.of(actions.getApiKeyForOrgFailed({ error, orgId }))
        })
    })
}

const createApiKeyForOrgEpic = (action$, { getState }) => {
  return action$
    .ofType(actions.createApiKeyForOrg.toString())
    .pluck('payload')
    .switchMap(() => {
      const orgId = fetchOrgId(getState())

      return api
        .createApiKeyForOrg(orgId)
        .map((response) => actions.createApiKeyForOrgSuccess(response))
        .startWith(actions.createApiKeyForOrgPending(orgId))
        .catch(error => {
          return Observable.of(actions.createApiKeyForOrgFailed({ error, orgId }))
        })
    })
}

export const epic = combineEpics(
  getApiKeyForOrgEpic,
  createApiKeyForOrgEpic
)


// WEBPACK FOOTER //
// ./src/scripts/app/modules/apiKey/epic.js